/* src/app/views/vehicle-information/vehicle-information.component.scss */
.container {
  --surface-strong: #ffffff;
  --surface-soft: #ffffff;
  --border-subtle: #d9e1ea;
  --text-primary: #1f2937;
  --text-muted: #66758a;
  --action-primary: #046cea;
  --action-primary-hover: #044ea7;
  --info-width: min(980px, 94%);
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border: 1px solid #dbe3ec;
  border-radius: 10px;
  box-shadow: 0 6px 18px rgba(15, 23, 42, 0.08);
  overflow: hidden;
}
.container-header {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  padding: 28px 42px 12px 42px;
}
.title {
  font-weight: 400;
  font-style: normal;
  font-size: 44px;
  line-height: 1.08;
  color: #17345c;
  margin: 0;
}
.container-body {
  flex: 1;
  display: flex;
  flex-direction: column;
  border: none;
}
.vehicle-info-wrapper {
  padding: 8px 42px 30px 42px;
}
.vehicle-layout {
  width: var(--info-width);
  margin: 0 auto;
  display: grid;
  grid-template-columns: minmax(280px, 360px) minmax(420px, 1fr);
  gap: 22px;
  align-items: stretch;
}
.vehicle-hero-card,
.vehicle-details-card {
  background: #ffffff;
  border: 1px solid var(--border-subtle);
  border-radius: 12px;
  padding: 22px;
  box-sizing: border-box;
}
.vehicle-hero-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 14px;
  background: var(--surface-strong);
}
.image-car {
  width: min(300px, 70vw);
  height: auto;
  margin: 0;
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.12));
}
.label-name-car {
  font-family: Ford Antenna !important;
  font-style: normal;
  font-weight: 600;
  color: #214a7a;
  font-size: 24px;
  line-height: 1.25;
  margin: 0;
  text-align: center;
}
.vehicle-details-card {
  display: flex;
  flex-direction: column;
  gap: 20px;
  background: var(--surface-strong);
}
.vehicle-info-content {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  column-gap: 18px;
  row-gap: 14px;
}
.vehicle-info-item {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 5px;
  padding: 12px;
  border-radius: 10px;
  background: #ffffff;
  border: 1px solid #e1e7ef;
  min-height: 80px;
  box-sizing: border-box;
  grid-column: span 2;
}
.vehicle-info-item--chassi,
.vehicle-info-item--warranty {
  grid-column: span 3;
  min-width: 0;
}
.info-label {
  font-size: 13px;
  line-height: 1.25;
  font-weight: 500;
  color: #718198;
  margin: 0;
}
.info-value {
  font-size: 17px;
  line-height: 1.25;
  font-weight: 600;
  color: var(--text-primary);
  word-break: break-word;
}
.warranty-date-wrapper {
  width: 100%;
}
.info-value--warranty {
  display: block;
  white-space: nowrap;
  overflow-wrap: normal;
  word-break: normal;
  font-size: clamp(14px, 1.05vw, 17px);
  line-height: 1.2;
}
.monospace {
  font-family:
    "Consolas",
    "Courier New",
    monospace;
  font-size: 15px;
  letter-spacing: 0.3px;
}
.show-date {
  margin-bottom: 0;
}
.hide-date {
  margin-bottom: 0;
}
.odometer-panel {
  padding: 16px;
  border-radius: 12px;
  border: 1px solid #d7e0ea;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 2px;
}
.odometer-row {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
}
.odometer-input {
  width: min(440px, 100%);
}
:host ::ng-deep .odometer-input .p-inputtext,
:host ::ng-deep .odometer-input .p-inputnumber-input {
  height: 54px;
  font-size: 17px;
  font-weight: 600;
  width: 100%;
  border: 1px solid #c3cfdb;
  border-radius: 12px;
  background: #ffffff;
  padding: 0 18px;
  color: #23304a;
}
:host ::ng-deep .odometer-input .p-inputtext:focus,
:host ::ng-deep .odometer-input .p-inputnumber-input:focus {
  border-color: #8ca6c5;
  box-shadow: 0 0 0 3px rgba(140, 166, 197, 0.18);
  outline: none;
}
.odometer-unit {
  font-size: 16px;
  font-weight: 600;
  line-height: 1;
  color: #1d3456;
}
.button-position {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 18px 42px 20px 42px;
  margin: 0;
  border-top: 1px solid #d4dde8;
  box-sizing: border-box;
  background: #ffffff;
}
.action-button {
  width: 220px;
  height: 48px;
  background: var(--action-primary);
  border: 1px solid var(--action-primary);
  border-radius: 10px;
  margin-top: 0;
  margin-right: 0;
}
.action-button-label {
  font-size: 15pt;
  font-weight: 500;
  color: #ffffff;
}
.action-button:disabled {
  background-color: #e5e5e5;
  cursor: not-allowed;
  border: 1px solid #aaaaaa;
  opacity: 0.75;
}
.action-button:disabled .action-button-label {
  color: #202020;
}
.action-button:hover:not(:disabled) {
  background: var(--action-primary-hover);
}
.action-button:disabled:hover {
  background-color: #e5e5e5;
  color: #202020;
  cursor: not-allowed;
  border: 1px solid #aaaaaa;
}
.action-button:disabled:hover .action-button-label {
  color: #202020;
}
.undo-action-button {
  background: #ffffff;
  border: 1px solid var(--action-primary);
  border-radius: 10px;
  margin-top: 0;
  margin-right: 0;
}
.undo-action-button-label {
  font-size: 15pt;
  font-weight: 500;
  color: var(--action-primary);
  margin-left: 5px;
}
.clear {
  width: 250px;
  height: 48px;
}
.return {
  width: 137px;
  height: 48px;
}
.undo-action-button:hover {
  background: var(--action-primary-hover);
}
button.undo-action-button:hover .undo-action-button-label {
  color: #ffffff;
}
@media (max-width: 1200px) {
  .title {
    font-size: 36px;
  }
  .vehicle-layout {
    grid-template-columns: minmax(260px, 330px) minmax(320px, 1fr);
  }
  .vehicle-info-content {
    grid-template-columns: repeat(2, minmax(180px, 1fr));
  }
  .vehicle-info-item--chassi,
  .vehicle-info-item--warranty {
    grid-column: span 1;
  }
  .label-name-car {
    font-size: 22px;
  }
}
@media (max-width: 960px) {
  .container-header {
    padding: 20px 22px 10px 22px;
  }
  .title {
    font-size: 28px;
    line-height: 1.15;
  }
  .vehicle-info-wrapper {
    padding: 8px 22px 24px 22px;
  }
  .button-position {
    padding: 16px 22px;
  }
  .vehicle-layout {
    grid-template-columns: 1fr;
    width: min(680px, 100%);
  }
  .vehicle-info-content {
    grid-template-columns: repeat(2, minmax(160px, 1fr));
  }
  .image-car {
    width: min(280px, 58vw);
  }
}
@media (max-width: 640px) {
  .container-header {
    padding: 16px 14px 8px 14px;
  }
  .title {
    font-size: 24px;
  }
  .vehicle-info-wrapper {
    padding: 6px 14px 18px 14px;
  }
  .vehicle-hero-card,
  .vehicle-details-card {
    padding: 14px;
  }
  .label-name-car {
    font-size: 20px;
  }
  .vehicle-info-content {
    grid-template-columns: 1fr;
  }
  .info-value,
  .monospace {
    font-size: 15px;
  }
  .odometer-row {
    gap: 8px;
  }
  :host ::ng-deep .odometer-input .p-inputtext,
  :host ::ng-deep .odometer-input .p-inputnumber-input {
    height: 48px;
    font-size: 16px;
    padding: 0 14px;
  }
  .odometer-unit {
    font-size: 15px;
  }
  .button-position {
    flex-direction: column;
    align-items: stretch;
    padding: 14px;
  }
  .action-button,
  .undo-action-button,
  .clear,
  .return {
    width: 100%;
    margin-right: 0;
    margin-top: 8px;
  }
}
.action-button,
.undo-action-button,
.clear,
.return {
  min-width: 120px;
  max-width: 100%;
  box-sizing: border-box;
}
/*# sourceMappingURL=vehicle-information.component-NRZZ5SE5.css.map */
